<template>
  <modal
    :title="setModel != undefined ? 'Update Country' : 'Add Country'"
    @close="$emit('close')"
  >
    <template #content>
      <loadArea v-if="languages == null || currencies == null"></loadArea>
      <Form
        method="dialog"
        v-slot="{ errors }"
        class="floating-labels p-1rem"
        ref="form"
        v-if="languages != null && currencies != null"
      >
        <formGroup
          :title="'Name'"
          v-model="model.Name"
          :errors="errors"
          :rules="{ required: true }"
          @keydown.enter="save"
        ></formGroup>
        <formGroup
          :title="'ISO2'"
          v-model="model.ISO2"
          :errors="errors"
          :rules="{ required: true }"
          @keydown.enter="save"
        ></formGroup>
        <formGroup
          :title="'ISO3'"
          v-model="model.ISO3"
          :errors="errors"
          :rules="{ required: true }"
          @keydown.enter="save"
        ></formGroup>
        <formGroup
          :title="'CurrencyCode'"
          :as="'select'"
          :disabled="currencies.length == 0"
          :buttons="true"
          v-model="model.CurrencyCode"
          :errors="errors"
          @keydown.enter="save"
        >
          <template #input>
            <option :value="null"></option>
            <option
              v-for="item in currencies"
              :value="item.Code"
              :key="item.Code"
              >{{ item.Name }}</option
            >
          </template>
          <template #buttons>
            <button
              type="button"
              @click="addCurrenciesOpen = true"
              class="btn waves-effect waves-light btn-success"
            >
              <i class="fas fa-plus"></i>
            </button>
          </template>
        </formGroup>
        <formGroup
          :title="'LanguageCode'"
          :as="'select'"
          v-model="model.LanguageCode"
          :disabled="currencies.length == 0"
          :buttons="true"
          :errors="errors"
          @keydown.enter="save"
        >
          <template #input>
            <option :value="null"></option>
            <option
              v-for="item in languages"
              :value="item.Code"
              :key="item.Code"
              >{{ item.Name }}</option
            >
          </template>
          <template #buttons>
            <button
              type="button"
              @click="addLanguagesOpen = true"
              class="btn waves-effect waves-light btn-success"
            >
              <i class="fas fa-plus"></i>
            </button>
          </template>
        </formGroup>
        <formGroup
          :title="'SletatId'"
          type="number"
          v-model.number="model.SletatId"
          :errors="errors"
          @keydown.enter="save"
        ></formGroup>
      </Form>
    </template>
    <template #foot>
      <Btn
        class="btn-success btn-md"
        @click="save"
        :disabled="languages == null || currencies == null"
        :process="process"
        >{{ setModel != undefined ? "Update Country" : "Add Country" }}</Btn
      >
    </template>
  </modal>
  <addCurrencies
    v-if="addCurrenciesOpen"
    @close="addCurrenciesOpen = false"
    @add="currencies.push({ Code: $event.Code, Name: $event.Name })"
  ></addCurrencies>
  <addLanguages
    v-if="addLanguagesOpen"
    @close="addLanguagesOpen = false"
    @add="languages.push({ Code: $event.Code, Name: $event.Name })"
  ></addLanguages>
</template>

<script>
import addCurrencies from "@/views/currencies/upsert";
import addLanguages from "@/views/languages/upsert";
export default {
  props: {
    setModel: Object,
  },
  components: { addCurrencies, addLanguages },
  data() {
    return {
      addCurrenciesOpen: false,
      addLanguagesOpen: false,
      model: {
        Id: null,
        Name: "",
        ISO2: "",
        ISO3: "",
        CurrencyCode: "",
        LanguageCode: "",
        SletatId: null,
      },
      languages: null,
      currencies: null,
      process: false,
    };
  },
  created() {
    if (this.setModel != undefined) {
      this.model = { ...this.setModel };
    }
    this.$appAxiosAdmin.get("Languages").then((response) => {
      this.languages = response.data;
    });
    this.$appAxiosAdmin.get(`Currencies`).then((response) => {
      this.currencies = response.data;
    });
  },
  methods: {
    save() {
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          this.process = true;
          this.$appAxiosAdmin
            .put(`Countries`, this.model)
            .then((response) => {
              this.process = false;
              this.$swal({
                icon: "success",
                title: "Success",
                text:
                  this.setModel != undefined
                    ? "The country has been successfully updated."
                    : "The country has been successfully added.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
              if (this.setModel != undefined) {
                this.$emit("update", response.data);
              } else {
                this.$emit("add", response.data);
              }
              this.$emit("close");
            })
            .catch((err) => {
              this.process = false;
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>

<style></style>
